import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UiModule } from '../shared/ui/ui.module';
import { WidgetModule } from '../shared/widget/widget.module';

import { PagesRoutingModule } from './pages-routing.module';
import { SimplebarAngularModule } from 'simplebar-angular';
import { NgbNavModule, NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { SharedModule } from '../shared/shared.module';
import { EStampModule } from './e-stamp/e-stamp.module';
import { DocumentationComponent } from './documentation/documentation.component';

@NgModule({
  declarations: [
    DocumentationComponent
  ],

  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PagesRoutingModule,
    UiModule,
    NgbNavModule,
    NgbDropdownModule,
    NgbTooltipModule,
    SimplebarAngularModule,
    SharedModule,
    DragDropModule,
    TableModule,
    InputTextModule,
    DropdownModule,
    CalendarModule,
    EStampModule
  ],
  providers: [
  ]
})
export class PagesModule { }
